<template>

  <div style="display: flex; flex-direction: column;">
    <div class="hd">未来治理</div>
    <dv-scroll-board :config="config" style="flex: 1; width:100%"/>
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
export default {
  name: 'Property',
  data () {
    return {
      config: {
        header: ['日期', '时间', '问题', '处理结果'],
        data: [
          ['2021-01-01', '8:00', '问题A', '已处理'],
          ['2021-01-02', '9:00', '问题B', '已处理'],
          ['2021-01-03', '10:00', '问题C', '已处理'],
          ['2021-01-04', '11:00', '问题D', '已处理'],
        ],
        index: true,
        columnWidth: [50, 100, 60, 100, 80],
        align: ['center'],
        rowNum: 2,
        headerBGC: '#1981f6',
        headerHeight: 32,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hd {
  font-size: 24px;
  font-weight: 600;
}
</style>
